module.exports = __webpack_public_path__ + "static/media/picto_type_lab.fd71edce.svg";